// extracted by mini-css-extract-plugin
module.exports = {"sample":"labelWithBoxUI_sample__wq-8h","errorInput":"labelWithBoxUI_errorInput__1ppOV","errorLabel":"labelWithBoxUI_errorLabel__LFrOO"};